import React from 'react';
import { SectionWrapper } from './SectionWrapper';
import { TestimonialCard } from './TestimonialCard';
import FavoriteIcon from '@mui/icons-material/Favorite';
export function MoreTestimonialsSection() {
  const testimonials = [{
    initials: 'CR',
    quote: 'El plan de 14 días me organizó la vida. Antes no sabía qué comer. Ahora tengo todo resuelto y mi hinchazón desapareció en la primera semana.',
    name: 'Cecilia R.',
    location: '📍 Mendoza'
  }, {
    initials: 'SC',
    quote: 'Los 7 errores me abrieron los ojos. Estaba cometiendo 5 de los 7 sin saberlo. Todo cambió cuando los identifiqué.',
    name: 'Sofía C.',
    location: '📍 La Plata'
  }, {
    initials: 'PA',
    quote: 'El recetario es oro. Las recetas son simples, ricas y en serio no tardás nada. Ya no tengo excusa para no comer bien.',
    name: 'Paula A.',
    location: '📍 Neuquén'
  }, {
    initials: 'JM',
    quote: 'Nunca pensé que la lista de compras podía cambiar tanto. Iba al super sin sistema y volvía con lo que me saboteaba. Eso terminó.',
    name: 'Julia M.',
    location: '📍 Rosario'
  }];
  return <SectionWrapper className="bg-white" data-id="element-158">
      <div className="text-center mb-12" data-id="element-159">
        <div className="inline-flex items-center justify-center w-12 h-12 rounded-full bg-red-50 text-red-500 mb-4" data-id="element-160">
          <FavoriteIcon data-id="element-161" />
        </div>
        <h2 className="font-serif text-3xl md:text-4xl font-bold text-primary mb-4" data-id="element-162">
          MÁS PERSONAS QUE YA LO VIVIERON
        </h2>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-163">
        {testimonials.map((t, i) => <TestimonialCard key={i} {...t} data-id="element-164" />)}
      </div>
    </SectionWrapper>;
}